// kepler_front_new/src/pages/ManufactureStatus/utils/fetch.js
import { message } from "antd";
import config from "../../../config.json";
import {
  patchRequest,
  postRequest,
  getRequest,
  formatRequestError,
} from "../../../utils/requests";

export const fetchStatuses = (
  state = "NEW",
  status = "",
  query = "",
  setSpecifications = () => {},
  setIsLoading = () => {},
  setTotalCount = () => {},
  page = 1,
  size = 20
) => {
  const url = `${config.service}/api/appl/production-status?search=${encodeURIComponent(query)}`;

  const body = { state, page, size };
  if (status) {
    body.status = status;
  }

  return postRequest(url, body, {})
    .then((data) => {
      const orders = data.data?.orders || data.data || [];
      setSpecifications(Array.isArray(orders) ? orders : []);
      setTotalCount(data.data?.totalCount ?? (Array.isArray(orders) ? orders.length : 0));
      return { currentPage: data.data?.currentPage ?? page };
    })
    .catch((err) => {
      console.error("Ошибка загрузки статусов:", err);
      message.error(formatRequestError("Ошибка загрузки данных", err));
      return { currentPage: page };
    })
    .finally(() => {
      setIsLoading(false);
    });
};

// Загрузка через общий эндпоинт state (с пагинацией)
export const fetchStateStatuses = (
  state = "NEW",
  status = "",
  query = "",
  setSpecifications = () => {},
  setIsLoading = () => {},
  setTotalCount = () => {},
  page = 1,
  size = 20
) => {
  setIsLoading(true);
  const url = `${config.service}/api/appl/state?search=${encodeURIComponent(query)}`;
  const body = { state, page, size };
  if (status) body.status = status;

  return postRequest(url, body)
    .then((res) => {
      const apps = Array.isArray(res?.data?.application) ? res.data.application : [];
      setSpecifications(apps);
      setTotalCount(res?.data?.totalCount ?? 0);
      return {
        currentPage: res?.data?.currentPage ?? page,
        totalCount: res?.data?.totalCount ?? 0,
      };
    })
    .catch((err) => {
      const msg = err?.response?.data?.message || "Ошибка загрузки данных";
      message.error(msg);
      throw err;
    })
    .finally(() => setIsLoading(false));
};

export const fetchSpecificationOrders = (specificationId, setOrders = () => {}, setIsLoading = () => {}) => {
  const url = `${config.service}/api/appl/orders-for-specification/${specificationId}`;
  getRequest(url)
    .then((data) => {
      setOrders(data.data?.products.orders || []);
    })
    .catch((err) => {
      console.error("Ошибка загрузки спецификации:", err);
      message.error(formatRequestError("Ошибка загрузки спецификации", err));
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const acceptApplication = (id, onFinish) => {
  const url = `${config.service}/api/appl/changeState/${id}`;
  const body = { state: "ACTIVE", status: "PRODUCTION" };

  const response = patchRequest(url, body);
  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Готово", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
      if (onFinish) onFinish();
    });
};

export const refuseApplication = (id, onFinish) => {
  const url = `${config.service}/api/appl/changeState/${id}`;
  const body = { state: "NEW", status: "REFUSED" };

  const response = patchRequest(url, body);
  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Готово", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
      if (onFinish) onFinish();
    });
};

export const completeApplication = (id, isHasAssembly, onFinish) => {
  const url = `${config.service}/api/appl/changeState/${id}`;
  const body = isHasAssembly
    ? { state: "ACTIVE", status: "PASSED_TO_ASSEMBLY" }
    : { state: "ACTIVE", status: "READY_FOR_SHIPMENT" };

  const response = patchRequest(url, body);
  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Готово", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
      if (onFinish) onFinish();
    });
};

export const updateApplication = (id, body, onFinish) => {
  const url = `${config.service}/api/appl/changeStatus/${id}`;
  const response = patchRequest(url, body);
  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Обновлено", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
      if (onFinish) onFinish();
    });
};

export const updateApplicationStatus = (id, body, onFinish) => {
  const url = `${config.service}/api/appl/changeStatus/${id}`;
  const response = patchRequest(url, body);
  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Обновлено", 3);
      if (onFinish) onFinish();
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const sendToProduction = (id) => {
  const hideLoadingMsg = message.loading("Отправка на производство", 0);
  const url = `${config.service}/api/appl/production/${id}`;
  const response = postRequest(url, { status: "REVIEW", state: "ACTIVE" });
  response
    .then(() => {
      message.success("Спецификация успешно отправлена на производство", 3);
    })
    .catch((err) => {
      message.error(
        formatRequestError("Не удалось отправить на производство", err),
        3
      );
    })
    .finally(() => {
      hideLoadingMsg();
    });
};
